<template>
  <div>


    <CCard>
      <CCardHeader>
        لیست فروشگاه

      </CCardHeader>
      <CCardBody>
        <CDataTableFixed
            :items="items"
            :fields="fields"
            column-filter
            :items-per-page="20"
            hover
            sorter
            pagination
        >
          <template #row="{item,index}">

            <td>
              <p class="text-muted">{{ index + 1 }}</p>

            </td>

          </template>


          <template #logo="{item}">


            <td>
              <CImg  width="50px" height="50px" v-bind:src="item.logo"/>
            </td>

          </template>
          <template #created_at="{item}">
            <td>
             <p>{{get_date(item.created_at)}}</p>
            </td>
          </template>



          <template #admin_name="{item}">
            <td>
             <p>{{(item.admin.name)}}</p>
            </td>
          </template>
          <template #admin_phone="{item}">
            <td>
             <p>{{(item.admin.phone)}}</p>
             <p>{{(item.admin.email)}}</p>
            </td>
          </template>

          <template #favicon="{item}">
            <td>
              <CImg  width="50px" height="50px" v-bind:src="item.favicon"/>
            </td>

          </template>

          <template #operation="{item,index}">
            <td class="py-2">
              <CButton
                  color="warning"
                  variant="outline"
                  square
                  class="m-1"
                  size="sm"
                  @click="editDetails(item,index)"
              >
                <CIcon name="cil-pencil" size="sm"/>
              </CButton>
              <CButton
                  color="primary"
                  variant="outline"
                  square
                  class="m-1"
                  size="sm"
                  @click="go_show_product(item)"
              >{{ $t('view') }}
              </CButton>

            </td>
          </template>


        </CDataTableFixed>

      </CCardBody>

    </CCard>

    <CInputFile
        custom
        horizontal
        id="excel_uploader_file"
        v-show="false"

        v-on:change="handleFileUpload"
    />
  </div>

</template>

<script>
import axios from "axios";
import {bus} from "../../main";


export default {
  name: 'Login',
  components: {
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {
      confirm_delete_name: new Date().getTime() + "_" + this.$vnode.tag,
      checkbox_ids:[],
      name: '',
      file: '',
      color: '',
      previewImage: '',
      description: '',
      excel_file: null,
      items: [],
      fields: [
        {key: 'row', label: '#', _style: 'width:3%', sorter: false, filter: false},
        {key: 'logo', label:this.$t('image') , _style: 'width:7%'},
        {key: 'name', label: this.$t('name'), _style: 'width:25%'},
        {key: 'market_code', label: this.$t('code'), _style: 'width:7%'},
        // {key: 'type', label: 'نوع', _style: 'width:7%;'},
        // {key: 'price', label: this.$t('price'), _style: 'width:13%;'},
        // {key: 'stock', label: this.$t('stock'), _style: 'width:7%;'},
        {key: 'created_at', label: "تاریخ ثبت نام", _style: 'width:5%;'},
        {key: 'admin_name', label: "نام مدیر", _style: 'width:5%;'},
        {key: 'admin_phone', label: "موبایل مدیر", _style: 'width:5%;'},
        {key: 'operation', label: this.$t('operation'), _style: 'width:12%;'},

      ],
      filters: [
        {label: this.$t('active_items'), value: 1},
        {label: this.$t('deactivate_items'), value: 2},
      ],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  },
  mounted() {
    this.get_data();
    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == 'true') {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  },
  watch: {
    '$route.params.cat_id': function (id) {
      this.get_data();
    },
    'excel_file': function () {
      this.upload_excel();
    }
  },
  methods: {

    editDetails(item, index) {
      this.$router.push({path: "/dashboard/markets/edit-market/" + item.id});

    },

    go_show_product(item) {
      window.open(localStorage.getItem("web_address")  + item.market_code, "_blank");
    },
    get_data() {
      var self = this;

      var formData = new FormData();
      var url = '/api/super-admin/markets/get_markets';

      axios.post(url, formData, {}).then(function (response) {


        self.items = response.data;
        self.items.forEach(function (val) {
          val.name = val.title.title
        })

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    goAddNews() {

      this.$router.push({path: '/dashboard/products/create'});
    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal('اخطار', "آیا مایل به حذف این ردیف هستید؟", ['تایید'], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/delete_product";


      formData.append('post_id', this.status_form);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    deactive_product(item) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "/api/admin/product/deactive_product";
      if (item.status == 2) {
        url = "/api/admin/product/active_product";
      }

      formData.append('post_id', item.id);

      axios.post(url, formData, {}).then((response) => {
        self.$root.modal_component.show_api_response_modals(response);

        self.status_form = 0;

        self.get_data();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    handleFileUpload(files, e) {
      console.log("handle upload")
      var myfile = e.target.files[0];
      if (myfile == null) {
        return
      }

      // e.target.value = '';
      // e.target.files = '';
      this.excel_file = myfile
      e.target = null
    },
    open_file_selector() {
      document.getElementById("excel_uploader_file").click()
    },
  }
}


</script>
